<template>
  <div>{{ point | formatTotalPoint }}{{ $t("pointShortcut") }}</div>
</template>
<script>

export default {
  props: ['oldPoint', 'totalPoint', 'hasLeaderboardSwap'],
  data() {
    return {
      requestFrame: null,
      point: 0,
      processPoint: 0,
    }
  },
  destroyed() {
    if (this.requestFrame) {
      cancelAnimationFrame(this.requestFrame)
      this.requestFrame = null
    }
  },
  mounted() {
    this.point = this.oldPoint
    this.processPoint = this.totalPoint - this.oldPoint
    this.updateOldPoint()
  },

  methods: {
    updateOldPoint() {
      const animationDuration = this.hasLeaderboardSwap ? 1500 : 2200
      const endTime = new Date().getTime() + animationDuration

      if (this.point === this.totalPoint) return

      const step = () => {
        const currentTime = endTime - new Date().getTime()
        if (currentTime <= 0) {
          this.point = this.totalPoint
          this.requestFrame = null
        } else {
          this.point =
            this.oldPoint + parseInt((((animationDuration - currentTime) / animationDuration) * this.processPoint), 10)
          this.requestFrame = window.requestAnimationFrame(step)
        }
      }

      this.requestFrame = window.requestAnimationFrame(step)
    },
  },
}
</script>
